module.exports = __webpack_public_path__ + "static/media/Sketch2.9a11eb00.jpeg";